import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FavoriteItem, ImagesState } from "./index.types";

const initialState: ImagesState = {
  unfavoritedImages: [],
};

export const imagesSlice = createSlice({
  name: "images",
  initialState,
  reducers: {
    // Used to inform the images section which images are unfavorited.
    addUnfavoritedImage: (state, action: PayloadAction<FavoriteItem>) => {
      state.unfavoritedImages.push(action.payload);
    },
  },
});

export const { addUnfavoritedImage } = imagesSlice.actions;

export const selectUnfavoritedImages = (state: any) => state.images.unfavoritedImages;

export default imagesSlice.reducer;
